package dev.lingvo.shared.screenshots.text

/** Japanese punctuation constraints are shared by browser word and common character segmentation. */
object Kinsoku {
    /** Explicit SPEC-B set avoids platform-dependent punctuation classifications. */
    const val noStart: String = "、。，．・：；？！ー‐」』）】〕〉》…‥々ゝゞぁぃぅぇぉっゃゅょゎァィゥェォッャュョヮヵヶ)]},.!?;:"
    /** Opening brackets belong with the phrase they introduce. */
    const val noEnd: String = "「『（【〔〈《〘〖｛［([{"

    /** Uses supplied dictionary boundaries without permitting forbidden punctuation at a line edge. */
    fun phrases(words: List<Segment>): List<Segment> = constrain(buildList {
        for (word in words) {
            val particle = word.text.length in 1..2 && word.text.all { it in '\u3041'..'\u3096' }
            val previous = lastOrNull()
            if (particle && previous != null && previous.breakAfter != Brk.HARD) {
                removeAt(lastIndex)
                add(Segment(previous.text + word.text, word.breakAfter))
            } else add(word)
        }
    })

    /** Scalar iteration preserves surrogate pairs; combining and joiner sequences stay attached. */
    fun characters(text: String): List<Segment> {
        val units = mutableListOf<Segment>()
        var i = 0
        while (i < text.length) {
            val start = i
            val c = text[i++]
            if (c.isHighSurrogate() && i < text.length && text[i].isLowSurrogate()) i++
            val part = text.substring(start, i)
            val category = c.category
            val attached = category == CharCategory.NON_SPACING_MARK || category == CharCategory.COMBINING_SPACING_MARK ||
                category == CharCategory.ENCLOSING_MARK || c == '\u200d' || c in '\ufe00'..'\ufe0f' ||
                units.lastOrNull()?.text?.endsWith('\u200d') == true
            val kind = when (c) {
                '\n' -> Brk.HARD
                ' ' -> Brk.SPACE
                '\u00ad' -> Brk.SOFT_HYPHEN
                else -> Brk.ALLOWED
            }
            if (attached && units.isNotEmpty() && units.last().breakAfter != Brk.HARD) {
                val previous = units.removeAt(units.lastIndex)
                units.add(Segment(previous.text + part, kind))
            } else units.add(Segment(part, kind))
        }
        return constrain(units)
    }

    private fun constrain(words: List<Segment>): List<Segment> = buildList {
        for (word in words) {
            var current = word
            val glue = "\u00a0\u202f\u2060"
            while (isNotEmpty()) {
                val previous = last()
                val left = previous.text.lastOrNull { it != ' ' }
                val right = current.text.firstOrNull { it != ' ' }
                if (previous.breakAfter == Brk.HARD ||
                    !(left != null && (left in noEnd || left in glue) || right != null && (right in noStart || right in glue))) break
                removeAt(lastIndex)
                current = Segment(previous.text + current.text, current.breakAfter)
            }
            add(current)
        }
    }
}
